import styles from "./HamburgerToggle.module.scss";

const HamburgerToggle = ({ isOpen, toggle }: any) => {
  return (
    <button
      aria-label="Toggle menu"
      aria-expanded={isOpen}
      onClick={()=>toggle}
      className={styles.hamburger}
    >
      <span
        className={`${styles.line} ${isOpen ? styles.line1Open : ""}`}
      ></span>
      <span
        className={`${styles.line} ${isOpen ? styles.line2Open : ""}`}
      ></span>
      <span
        className={`${styles.line} ${isOpen ? styles.line3Open : ""}`}
      ></span>
    </button>
  );
};

export default HamburgerToggle;
